import React from "react";

const HeroSection = ({ className, children }) => {
  return <div className={`hero ${className}`}>{children}</div>;
};

export default HeroSection;
